<template>
	<div class="copyright-detail">
		<!-- header -->
		<!-- <div class="copyright-detail.block">
			<intellectual-header></intellectual-header>
		</div> -->
		<!-- 导航栏 -->
		<div class="copyright-detail.block">
			<intellectual-navigation  :isTrademark="isTrademark" @toggleTrademarks="toggleTrademarks"></intellectual-navigation>
		</div>
		<div class="+navigation-line"></div>
		<!-- 面包屑 -->
		<div class="copyright-detail.bread">
			<Bread :currentPage="{name:'版权商城',path:'/Copyright',childName:'版权详情',childPath:$route.path}" />
		</div>
		<div class="copyright-detail.container">
            <common-detail :details="copyRightDetailFnl[0]"></common-detail>
			<copyright-intro></copyright-intro>
		</div>
		<!-- footer -->
		<common-footer></common-footer>
	</div>
</template>

<script>
	import IntellectualHeader from '../components/intellectual-header.vue'
	import IntellectualNavigation from '../components/intellectual-navigation.vue'
	import CommonFooter from "../components/common-footer.vue"
	import Bread from '../components/bread.vue'
	import CommonDetail from '../components/common-detail.vue'
    import CopyrightIntro from '../components/copyright-intro.vue'
	export default {
		components: {
			IntellectualHeader,
			IntellectualNavigation,
			CommonFooter,
			Bread,
			CommonDetail,
			CopyrightIntro

		},
		data(){
			return{
				isTrademark:false,
				copyRightDetail:[],
				copyRightType:['软件著作权','文字作品','美术作品','音乐作品','摄影作品','模型作品','录像作品','其他作品']
			}
		},
		computed:{
			copyRightDetailFnl(){
				return this.copyRightDetail.map(({ name, image, introduction, id,date_time,applyer,price,type}) => {
						return {
							type:'版权',
							name: name,
							icon: this.imgUrl + image,
							desc: introduction,
							id: id ,
							date:date_time,
							Application:applyer,
							price:price,
							tel:18152117607,
							tradeType:this.copyRightType[type - 1]
							
						}
					})
			}
		},
		methods:{
			toggleTrademarks(val){
				this.isTrademark = val
			},
			initCopyRightDetail(){
				this.http.get(`IPR_Copyright/${this.$route.params.id}`).then(res => {
					this.copyRightDetail = []
					this.copyRightDetail.push(res.data)	
				})
			}
		},
		mounted(){
			window.scrollTo(0,0);
			this.initCopyRightDetail()
		}
	}
</script>

<style lang="scss">
	@include component(copyright-detail) {
		@include part(block) {
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;
			width: 100%;
			background: #fff;
		}

		@include part(bread) {
			width: 100%;
			min-width: $minWidth;
			height: 51px;
			background: #fff;
		}

		@include part(container) {
			width: 100%;
			background: #F7F7F7;
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;

		}

	}
</style>
